import React, { useState } from "react";

const AVAILABLE_PARTS = [
  { id: "part1", label: "Part I – Regulation Part D Matters" },
  { id: "part2", label: "Part II – Investor Qualifications" },
  { id: "part3", label: "Part III – Accredited Status" },
  { id: "part4", label: "Part IV – Entity Details" },
  { id: "part5", label: "Part V – Miscellaneous" }
];

const EMPTY_SLOTS = [
  { id: "module1", label: "PDF Module 1" },
  { id: "module2", label: "PDF Module 2" },
  { id: "module3", label: "PDF Module 3" }
];

export default function FundBuilderPage() {
  const [fundName, setFundName] = useState("");
  const [modules, setModules] = useState({
    module1: null,
    moduleB: null,
    moduleC: null
  });
  const [selectedParts, setSelectedParts] = useState([]);
  const [dragOver, setDragOver] = useState(null);

  function handleFileDrop(e, slotId) {
    e.preventDefault();
    setDragOver(null);

    const file = e.dataTransfer.files[0];
    if (!file || file.type !== "application/pdf") return;

    setModules(prev => ({
      ...prev,
      [slotId]: file
    }));
  }

  function handleDragOver(e, slotId) {
    e.preventDefault();
    setDragOver(slotId);
  }

  function togglePart(partId) {
    setSelectedParts(prev =>
      prev.includes(partId)
        ? prev.filter(p => p !== partId)
        : [...prev, partId]
    );
  }

  function handleSaveFund() {
    const payload = {
      fundName,
      modules,
      selectedParts
    };

    console.log("📦 Fund Definition:", payload);

    alert("Fund configuration saved. Check console for payload.");
  }

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }}>
      <h1>🏗️ Fund Builder</h1>

      <section style={{ marginBottom: 32 }}>
        <label style={{ fontWeight: "bold" }}>Fund Name</label>
        <input
          type="text"
          value={fundName}
          onChange={e => setFundName(e.target.value)}
          placeholder="Example: Kasba Fund I, LP"
          style={{
            width: "100%",
            padding: 10,
            fontSize: 16,
            marginTop: 8
          }}
        />
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2>📄 PDF Modules</h2>
        <p>Drag & drop up to 3 PDF modules</p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
          {EMPTY_SLOTS.map(slot => (
            <div
              key={slot.id}
              onDrop={e => handleFileDrop(e, slot.id)}
              onDragOver={e => handleDragOver(e, slot.id)}
              onDragLeave={() => setDragOver(null)}
              style={{
                border: "2px dashed #999",
                borderColor: dragOver === slot.id ? "#007bff" : "#999",
                padding: 20,
                minHeight: 120,
                background: "#fafafa"
              }}
            >
              <strong>{slot.label}</strong>
              <div style={{ marginTop: 12 }}>
                {modules[slot.id] ? (
                  <span>✅ {modules[slot.id].name}</span>
                ) : (
                  <span>Drop PDF here</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2>🧩 Form Parts</h2>
        <p>Select which form sections to include</p>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {AVAILABLE_PARTS.map(part => (
            <label
              key={part.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: 8,
                border: "1px solid #ddd"
              }}
            >
              <input
                type="checkbox"
                checked={selectedParts.includes(part.id)}
                onChange={() => togglePart(part.id)}
              />
              {part.label}
            </label>
          ))}
        </div>
      </section>

      <button
        onClick={handleSaveFund}
        style={{
          padding: "12px 24px",
          fontSize: 16,
          background: "#007bff",
          color: "white",
          border: "none",
          cursor: "pointer"
        }}
      >
        💾 Save Fund Configuration
      </button>
    </div>
  );
}
